import { useEffect, useState } from 'react';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export interface FilterOption {
  id: number;
  name: string;
}

/**
 * Lightweight, active-only country options for filter dropdowns.
 * Backed by GET /api/filter/countries — unlike /api/country/all consumers that
 * need the full CountryDto, this never returns inactive countries.
 */
export const useFilterCountries = () => {
  const [countries, setCountries] = useState<FilterOption[]>([]);
  const httpClient = useHttpClient();

  useEffect(() => {
    const fetchFilterCountries = async () => {
      const response = await httpClient.current?.get('/api/filter/countries');
      const data = response?.data || [];
      setCountries(data.map((c: { id: number; label: string }) => ({ id: c.id, name: c.label })));
    };
    fetchFilterCountries();
  }, [httpClient]);

  return { countries };
};
